import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SearchDocLayout from "@/pages/search/SearchDocLayout";
import { CapabilitiesReturnLink } from "@/pages/search/KnowledgeChrome";
import { fetchService } from "@/lib/searchContent";

export default function ServiceLandingPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    setError("");
    fetchService(slug)
      .then(setData)
      .catch(() => {
        setData(null);
        setError("서비스 페이지를 찾을 수 없습니다.");
      });
  }, [slug]);

  const back = <CapabilitiesReturnLink />;

  if (error) {
    return (
      <SearchDocLayout
        testId="service-missing"
        item={{ title: error }}
        related={[{ href: "/services", label: "서비스 목록" }]}
        kicker="SERVICE"
        contextualBack={back}
      />
    );
  }
  if (!data?.item) {
    return (
      <SearchDocLayout
        testId="service-loading"
        item={{ title: "불러오는 중" }}
        kicker="SERVICE"
        contextualBack={back}
      />
    );
  }
  return (
    <SearchDocLayout
      testId="service-landing"
      item={data.item}
      related={data.related}
      kicker={data.item.eyebrow || "SERVICE"}
      contextualBack={back}
    />
  );
}
